import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {Alert,Container} from 'reactstrap';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';

// Settings
import Settings from '../../views/Settings/';

// Authentication
import withAuthentication from '../../components/withAuthentication';

// Authorization
import withAuthorization from '../../components/withAuthorization';

// Messaging
import withMessaging from '../../components/withMessaging';

// Subscriptions
import withSubscriptions from '../../components/withSubscriptions';

// Tesla Auth Status
import withTeslaAuthStatus from '../../components/withTeslaAuthStatus';

// Departure Schedules
import withDepartureSchedules from '../../components/withDepartureSchedules';

// Tesla Vehicles
import withTeslaVehicles from '../../components/withTeslaVehicles';

// Preferences
import withPreferences from '../../components/withPreferences';

// Departure Calendars
import withDepartureCalendars from '../../components/withDepartureCalendars';

// Leave Soon
import LeaveSoon from '../../views/LeaveSoon/';

// Schedules
import Schedules from '../../views/Schedules/';
import Schedule from '../../views/Schedule/';

// Add Schedule
import ScheduleAdd from '../../views/ScheduleAdd/';


class Full extends Component {
  render() {
    return (
      <div className="app">
        <Header/>
        <div className="app-body">
          <Sidebar {...this.props}/>
          <main className="main">
            <br/>
            <Container fluid>
			  <div className="d-md-none"><p>Tap or click the "hamburger" (three lines) icon in the upper-left to see the navigation menu.</p></div>
			  <AlertMissingTeslaCredentials show={this.context.teslaAuthStatus.status === 'none'}/>
			  <AlertInvalidTeslaCredentials show={this.context.teslaAuthStatus.status === 'invalid'}/>
              <Switch>
                <Route path="/leaveSoon" name="LeaveSoon" component={LeaveSoon}/>
                <Route path="/schedule/view/:departureScheduleId" name="Schedule" component={Schedule}/>
                <Route path="/schedule/add" name="Add Schedule" component={ScheduleAdd}/>
                <Route path="/schedule" name="Schedule" component={Schedules}/>
                <Route path="/settings" name="Settings" component={Settings}/>
                <Redirect from="/" to="/leaveSoon"/>
              </Switch>
            </Container>
          </main>
          <Aside/>
        </div>
        <Footer/>
      </div>
    );
  }
}

function AlertMissingTeslaCredentials(props) {
	if (!props.show) {
		return null;
	}
	
	return (
		<Alert color="primary">
		Please enter your Tesla credentials on the Settings page.
		</Alert>
	);
}

function AlertInvalidTeslaCredentials(props) {
	if (!props.show) {
		return null;
	}
	
	return (
		<Alert color="danger">
		Please update your Tesla credentials on the Settings page.
		</Alert>
	);
}

Full.contextTypes = {
	teslaAuthStatus: PropTypes.object.isRequired
}

const authCondition = (authUser) => !!authUser;

export default compose(
	withAuthentication,
	withAuthorization(authCondition),
	withMessaging,
	withSubscriptions,
	withPreferences,
	withTeslaAuthStatus,
	withDepartureSchedules,
	withTeslaVehicles,
	withDepartureCalendars
)(Full);



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js